//------------------------------------------------------------------------------
// BFA10104G 共架申込 通信設備 - 地図/径間描画
//------------------------------------------------------------------------------
import Graphic from '@arcgis/core/Graphic';
import Polyline from '@arcgis/core/geometry/Polyline';
import SimpleLineSymbol from '@arcgis/core/symbols/SimpleLineSymbol';
import PoleItem from '@/utils/pole-item';
import PoleLink from '@/utils/pole-link';
import { k1pole, k2pole } from './kkn-utils';

// 定数
const LOGH = 'BFA10104G draw keikan:';

/**
 * 径間一覧描画
 */
export function drawKeikan(layer, template, keikanList) {
  if (!layer) return;

  // 径間一覧から重複を除去
  const lines = new Map(keikanList.map((kkn) => {
    const pole1 = k1pole(kkn);
    const pole2 = k2pole(kkn);
    const poles = [pole1, pole2].sort(PoleItem.compare);
    const link = new PoleLink(poles.at(0), poles.at(1));
    return [ link.key(), link ];
  }));
  console.debug(LOGH, `keikan=${keikanList.length}, lines=${lines.size}`);

  // 径間一覧描画
  const lineGraphics = Array.from(lines.values())
      .filter((link) => link.pole1st.drawable())
      .filter((link) => link.pole2nd.drawable())
      .map((link) => keikanGraphic(link, template));
  layer.removeAll();
  layer.addMany(lineGraphics);
  console.debug(LOGH, `grpahics=${lineGraphics.length}`);
}

// 径間シンボル
const KEIKAN_SYMBOL = new SimpleLineSymbol({
  style: 'solid',
  width: '4px',
  color: 'black',
  marker: null,    // マーカなし
});

/**
 * 径間グラフィック作成
 */
function keikanGraphic(link, template) {
  const { pole1st, pole2nd } = link;

  // ライン
  const polyline = new Polyline({
    paths: [
      [ pole1st.longitude, pole1st.latitude ],
      [ pole2nd.longitude, pole2nd.latitude ],
    ],
  });

  // 属性
  const attributes = {
    type: 'keikan',
    link: link,
  };

  // グラフィック作成
  return new Graphic({
    symbol: KEIKAN_SYMBOL,
    geometry: polyline,
    attributes: attributes,
    popupTemplate: template,
  });
}
